import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";

class NonPlantillaFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  onChange(value, field) {
    this.object[field] = value;

    if (field === "isTwoPercent" && value) {
      this.object.isFivePercent = false;
    } else if (field === "isFivePercent" && value) {
      this.object.isTwoPercent = false;
    }

    this.view.setObject(this.object);
  }

  async save() {
    const collection = this.view.getCollectionName();
    try {
      this.upsertUseCase.execute(collection, this.object);

      this.showSuccess("Data Succesfully Updated");
    } catch (error) {
      throw error;
    }
  }
}

export default NonPlantillaFormPresenter;
